import { Column } from '@tanstack/react-table';

import { ChevronDownSmallIcon, ChevronUpSmallIcon } from '@/assets/icons';
import { cn } from '@/utils/tailwind';

type SortableHeaderProps = {
  column: Column<any, unknown>;
  text: string;
};

export const SortableHeader = ({ column, text }: SortableHeaderProps) => {
  const isSorted = column.getIsSorted();

  return (
    <button
      type="button"
      className="flex w-full min-w-0 cursor-pointer items-center gap-2 text-left"
      onClick={e => {
        e.stopPropagation();
        column.getToggleSortingHandler()?.(e);
      }}
    >
      <p>{text}</p>
      <div className="flex flex-col leading-none">
        <ChevronUpSmallIcon
          className={cn('size-4 -mb-1 transition-colors', {
            'text-blue-500': isSorted === 'asc',
            'text-gray-400': isSorted !== 'asc',
          })}
        />
        <ChevronDownSmallIcon
          className={cn('size-4 -mt-1 transition-colors', {
            'text-blue-500': isSorted === 'desc',
            'text-gray-400': isSorted !== 'desc',
          })}
        />
      </div>
    </button>
  );
};
